import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Statistic, Card } from "antd";
import {
  EditOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
import PriceAuditContext from "../../../context/price-audit/context";
import Spin from "../../general/antd/spin";
import styles from "./styles.module.scss";

const PriceAuditStats = () => {
  const { t } = useTranslation();
  const { statistics, loading } = useContext(PriceAuditContext);

  if (loading.includes("statistics")) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <Spin />
      </div>
    );
  }

  const stats = [
    {
      title: t("total_changes"),
      value: statistics?.totalChanges || 0,
      icon: <EditOutlined />,
      color: "#1890ff",
    },
    {
      title: t("post_payment_changes"),
      value: statistics?.postPaymentChanges || 0,
      icon: <WarningOutlined />,
      color: "#ff4d4f",
    },
    {
      title: t("pre_payment_changes"),
      value: statistics?.prePaymentChanges || 0,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
    },
    {
      title: t("changes_this_week"),
      value: statistics?.changesThisWeek || 0,
      icon: <CalendarOutlined />,
      color: "#faad14",
    },
    {
      title: t("changes_this_month"),
      value: statistics?.changesThisMonth || 0,
      icon: <CalendarOutlined />,
      color: "#722ed1",
    },
  ];

  return (
    <Row gutter={[16, 16]} className={styles.container}>
      {stats.map((stat, index) => (
        <Col xs={24} sm={12} md={8} lg={4} key={index}>
          <Card className={styles.card} bordered={false}>
            <div
              className={styles.iconWrapper}
              style={{ backgroundColor: `${stat.color}20` }}
            >
              <span style={{ color: stat.color, fontSize: "24px" }}>
                {stat.icon}
              </span>
            </div>
            <Statistic
              title={<span className={styles.title}>{stat.title}</span>}
              valueRender={() => (
                <span className={styles.value}>
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={1.5}
                    separator=","
                  />
                </span>
              )}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default PriceAuditStats;
